"use strict";
// Copyright (c) StrangeBee 2023
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class AnalyzerTemplateController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            create: '/connector/cortex/analyzer/template',
            edit: '/connector/cortex/analyzer/template/:objectId',
            delete: '/connector/cortex/analyzer/template/:objectId',
            import: '/connector/cortex/analyzer/template/_import',
        };
    }
    import(formData) {
        return this.manager.post({ url: this.endpoints.import }, formData, {
            headers: {
                'Content-Type': undefined,
            },
        });
    }
}
exports.default = AnalyzerTemplateController;
